export default __webpack_public_path__ + "static/media/008-wreath.b86cc7c6.svg";